import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function addDocumentFailure(draft: Draft<IInterventionData>) {
  draft.addDocument.config.isLoading = false;
}

export default addDocumentFailure;
